var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-wrapper",attrs:{"id":"loadWrapper"}},[_c('div',{attrs:{"id":"card-inner-wrapper"}},[_c('div',{attrs:{"id":"card-inner-wrapper-2"}},[_c('div',{staticClass:"card",attrs:{"id":"loadCard"}},[_c('img',{staticClass:"logo",attrs:{"id":"loadLogo","src":require("../assets/img/ulo_logo_full_white_transparent.png"),"alt":"","width":"100%"}})])])])])
}]

export { render, staticRenderFns }